import Link from 'next/link';
import { useMemo } from 'react';

import { useBrands } from '@api/catalog/brand';

import Picture from '@components/controls/future/Picture';
import { Slider, SliderSection, SliderSlide } from '@components/uiKit/Slider';
import sectionStyles from '@components/uiKit/Slider/ui/SliderSection.module.scss';

import { scale } from '@scripts/gds';
import { transformImageUrl } from '@scripts/helpers';

import styles from './BrandsCarousel.module.scss';

const BRAND_LOGO_WIDTH = 196;
const BRAND_LOGO_HEIGHT = 82;
const BRAND_LOGO_SRC_WIDTH = BRAND_LOGO_WIDTH * 2;
const BRAND_LOGO_SRC_HEIGHT = BRAND_LOGO_HEIGHT * 2;

const BrandsCarousel = () => {
    const { data: apiBrands } = useBrands({ filter: { is_popular: true } });
    const popularBrands = useMemo(() => apiBrands?.data, [apiBrands]);

    if (!popularBrands) {
        return null;
    }

    return (
        <SliderSection title="Популярные" spaceBetween={scale(3, true)} showViewAll={false}>
            {popularBrands.map((item, index) => (
                <SliderSlide key={index} className={sectionStyles.slide}>
                    <Link legacyBehavior href={`/brands/${item?.code}-${item.id}`} passHref prefetch={false}>
                        <a className={styles.brandLink} aria-label={item.name}>
                            {item?.image_url && (
                                <Picture
                                    sources={[
                                        {
                                            media: '',
                                            image: transformImageUrl(
                                                item.image_url,
                                                BRAND_LOGO_SRC_WIDTH,
                                                BRAND_LOGO_SRC_HEIGHT
                                            ),
                                        },
                                    ]}
                                    loading="lazy"
                                    placeholder="empty"
                                    alt={item.name}
                                    width={BRAND_LOGO_WIDTH}
                                    height={BRAND_LOGO_HEIGHT}
                                    style={{
                                        objectFit: 'contain',
                                        width: '100%',
                                        height: '100%',
                                    }}
                                />
                            )}
                        </a>
                    </Link>
                </SliderSlide>
            ))}
        </SliderSection>
    );
};

export default BrandsCarousel;
